import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { ChatIcon } from "@twilio-paste/icons/esm/ChatIcon";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { useDispatch, useSelector } from "react-redux";

import { changeExpandedStatus } from "../store/actions/genericActions";
import { AppState } from "../store/definitions";
import { containerStyles, textStyles } from "./styles/EntryPoint.styles";

export const EntryPoint = () => {
    const dispatch = useDispatch();
    const expanded = useSelector((state: AppState) => state.session.expanded);

    return (
        <Box
            as="button"
            data-test="entry-point-button"
            onClick={() => dispatch(changeExpandedStatus({ expanded: !expanded }))}
            {...containerStyles}
        >
            <Text as="p" display={["none", "block"]} {...textStyles}>
                Besoin d&apos;un conseil ?
            </Text>
            {expanded ? (
                <ChevronDownIcon decorative={false} title="Réduire la fenêtre" size="sizeIcon60" />
            ) : (
                <ChatIcon decorative={true} title="Démarrer une conversation" size="sizeIcon60" />
            )}
        </Box>
    );
};
